import React from 'react'
import {
    Grid,
    TextField,
} from '@mui/material';
import SectionTitle from '../../../ui/sectionTitle';

function ValidFramePropertiesForm({ formik }) {
    return (
        <>
            {/* Section 3: Frame Properties */}
            <Grid item xs={12}>
                <SectionTitle title="Frame Properties" />
            </Grid>

            <Grid container spacing={2}>
                {/* Section 3a: Measurements */}
                <Grid item xs={12} sm={6}>
                    <Grid item xs={12} mt={2}>
                        <TextField
                            value={formik.values.properties.aMeasurement}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.aMeasurement`, event.target.value);
                              }}
                            name="aMeasurement"
                            label="A (Eye Size)"
                            type="number"
                            size='small'
                            fullWidth
                            error={formik.touched.aMeasurement && Boolean(formik.errors.aMeasurement)}
                            helperText={formik.touched.aMeasurement && formik.errors.aMeasurement}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.bMeasurement}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.bMeasurement`, event.target.value);
                              }}
                            name="bMeasurement"
                            label="B (Lens Height)"
                            type="number"
                            size='small'
                            fullWidth
                            error={formik.touched.bMeasurement && Boolean(formik.errors.bMeasurement)}
                            helperText={formik.touched.bMeasurement && formik.errors.bMeasurement}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.dblMeasurement}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.dblMeasurement`, event.target.value);
                              }}
                            name="dblMeasurement"
                            label="DBL (Bridge)"
                            type="number"
                            size='small'
                            fullWidth
                            error={formik.touched.dblMeasurement && Boolean(formik.errors.dblMeasurement)}
                            helperText={formik.touched.dblMeasurement && formik.errors.dblMeasurement}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.templeLength}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.templeLength`, event.target.value);
                              }}
                            name="templeLength"
                            label="Temple Length"
                            type="number"
                            size='small'
                            fullWidth
                            error={formik.touched.templeLength && Boolean(formik.errors.templeLength)}
                            helperText={formik.touched.templeLength && formik.errors.templeLength}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.edMeasurement}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.edMeasurement`, event.target.value);
                              }}
                            name="edMeasurement"
                            label="ED (Effective Diameter)"
                            type="number"
                            size='small'
                            fullWidth
                            error={formik.touched.edMeasurement && Boolean(formik.errors.edMeasurement)}
                            helperText={formik.touched.edMeasurement && formik.errors.edMeasurement}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.circumference}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.circumference`, event.target.value);
                              }}
                            name="circumference"
                            label="Circumference"
                            type="number"
                            size='small'
                            fullWidth
                            error={formik.touched.circumference && Boolean(formik.errors.circumference)}
                            helperText={formik.touched.circumference && formik.errors.circumference}
                        />
                    </Grid>
                </Grid>

                {/* Section 3b: Properties and Colors */}
                <Grid item xs={12} sm={6}>
                    <Grid item xs={12} mt={2}>
                        <TextField
                            value={formik.values.properties.gender}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.gender`, event.target.value);
                              }}
                            name="gender"
                            label="Gender"
                            size='small'
                            fullWidth
                            error={formik.touched.gender && Boolean(formik.errors.gender)}
                            helperText={formik.touched.gender && formik.errors.gender}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.frameType}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.frameType`, event.target.value);
                              }}
                            name="frameType"
                            label="Frame Type"
                            size='small'
                            fullWidth
                            error={formik.touched.frameType && Boolean(formik.errors.frameType)}
                            helperText={formik.touched.frameType && formik.errors.frameType}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.shape}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.shape`, event.target.value);
                              }}
                            name="shape"
                            label="Shape"
                            size='small'
                            fullWidth
                            error={formik.touched.shape && Boolean(formik.errors.shape)}
                            helperText={formik.touched.shape && formik.errors.shape}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.material}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.material`, event.target.value);
                              }}
                            name="material"
                            label="Material"
                            size='small'
                            fullWidth
                            error={formik.touched.material && Boolean(formik.errors.material)}
                            helperText={formik.touched.material && formik.errors.material}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.color}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.color`, event.target.value);
                              }}
                            name="color"
                            label="Frame Color"
                            size='small'
                            fullWidth
                            error={formik.touched.color && Boolean(formik.errors.color)}
                            helperText={formik.touched.color && formik.errors.color}
                        />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TextField
                            value={formik.values.properties.lensColor}
                            onChange={(event) => {
                                formik.setFieldValue(`properties.lensColor`, event.target.value);
                              }}
                            name="lensColor"
                            label="Lens Color"
                            size='small'
                            fullWidth
                            error={formik.touched.lensColor && Boolean(formik.errors.lensColor)}
                            helperText={formik.touched.lensColor && formik.errors.lensColor}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default ValidFramePropertiesForm
